import { MpfInputBaseProps, mpfInputDefaults } from '../MpfInput/MpfInputBaseProps';

// ENG-17168 PDF uploads re-enabled (safe display via EmbedPDF); was removed under ENG-20629
const ACCEPT_ATTR = 'image/jpeg,image/png,image/tiff,application/pdf,.doc,.docx';

export interface MpfAttachmentsProps extends Omit<
  MpfInputBaseProps,
  'modelValue' | 'initialValue'
> {
  initialValue?: File[] | null;
  maxFiles?: number;
  maxFileSize?: number;
  modelValue?: File[] | null;
  accept?: string;
  multiple?: boolean;
}

export type MpfAttachmentsEmits = {
  (e: 'update:modelValue', value: File[]): void;
};

export const mpfAttachmentsDefaults = {
  ...mpfInputDefaults,
  modelValue: null,
  maxFiles: 10,
  maxFileSize: 2 * 1024 * 1024, // 10MB
  accept: ACCEPT_ATTR,
  size: 'small',
};
